import { CLAW_DEFAULT_OLLAMA_MODEL } from './clawDefaults.js';

/** Default local model (Ollama tag). Keep in sync with OLLAMA_MODEL_NAME / OLLAMA_PULL_MODEL. */
export const DEFAULT_OLLAMA_MODEL = CLAW_DEFAULT_OLLAMA_MODEL;

/** Ollama models shown in node/form model pickers (always available without API keys). */
export const OLLAMA_MODEL_OPTIONS = [
  { value: CLAW_DEFAULT_OLLAMA_MODEL, label: 'Qwen 2.5 Coder 14B', provider: 'ollama' },
  { value: 'gemma2:9b', label: 'Gemma 2 9B', provider: 'ollama' },
  { value: 'gemma3:4b', label: 'Gemma 3 4B', provider: 'ollama' },
  { value: 'llama3.1:8b', label: 'Llama 3.1 8B', provider: 'ollama' },
  { value: 'llama3', label: 'LLaMA 3', provider: 'ollama' },
  { value: 'qwen2.5:7b', label: 'Qwen 2.5 7B', provider: 'ollama' },
  { value: 'mistral', label: 'Mistral 7B', provider: 'ollama' },
  { value: 'codellama', label: 'Code LLaMA', provider: 'ollama' },
  { value: 'gpt-oss', label: 'GPT-OSS', provider: 'ollama' },
  { value: 'ollama', label: 'Ollama (default tag)', provider: 'ollama' },
];
